module.exports = __webpack_public_path__ + "static/media/covid_qr_p4_1.6ed97e60.png";